// QuotationSummary.jsx

import {
  Stack,
  Typography,
  IconButton,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import { AddCircleOutline, RemoveCircleOutline } from "@mui/icons-material";

const QuotationSummary = ({
  quantity,
  currencySymbol,
  bookInfo,
  onAdd,
  onReduce,
  handleChange,
}) => {
  const gatewayCharge = bookInfo?.advance
    ? Math.round(parseFloat(bookInfo?.advance) * 0.018 * quantity)
    : 0;

  const totalPayable = bookInfo?.advance
    ? Math.round(
        quantity * parseFloat(bookInfo?.advance) * 0.018 +
          parseFloat(bookInfo?.advance) * quantity
      )
    : 0;

  return (
    <Stack component="section" spacing={1} sx={{ padding: "20px" }}>

      {/* Quantity */}
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography fontSize="12pt">Service Quantity</Typography>
        <Stack direction="row" spacing={0.5} alignItems="center">
          <IconButton size="small" onClick={onReduce} color="error">
            <RemoveCircleOutline sx={{ fontSize: "18pt" }} />
          </IconButton>
          <Stack
            justifyContent="center"
            alignItems="center"
            sx={{
              width: "40px",
              height: "40px",
              border: "2px solid gray",
              borderRadius: "12px",
            }}
          >
            {quantity}
          </Stack>
          <IconButton size="small" onClick={onAdd} color="success">
            <AddCircleOutline sx={{ fontSize: "18pt" }} />
          </IconButton>
        </Stack>
      </Stack>

      {/* Budget */}
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography fontSize="12pt">Budget</Typography>
        <OutlinedInput
          size="small"
          type="number"
          name="budget"
          startAdornment={
            <InputAdornment position="start">
              <Typography>{currencySymbol}</Typography>
            </InputAdornment>
          }
          sx={{ width: "40%", marginRight: "9px" }}
          onChange={handleChange}
        />
      </Stack>

      {/* Advance */}
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography fontSize="12pt">Advance</Typography>
        <OutlinedInput
          size="small"
          type="number"
          name="advance"
          startAdornment={
            <InputAdornment position="start">
              <Typography>{currencySymbol}</Typography>
            </InputAdornment>
          }
          sx={{ width: "40%", marginRight: "9px" }}
          onChange={handleChange}
        />
      </Stack>

      {/* Gateway Charge */}
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography fontSize="12pt">Gateway Charge</Typography>
        <Typography fontSize="12pt" fontWeight={600} pr="40px">
          {currencySymbol} {gatewayCharge}
        </Typography>
      </Stack>

      {/* Total Payable */}
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography fontSize="12pt">Total Payable Amount</Typography>
        <Typography fontSize="12pt" fontWeight={600} pr="40px">
          {currencySymbol} {totalPayable}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default QuotationSummary;
